/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shoot_Share_ConnectInputs */

const en_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot · Share · Connect`)
};

const es_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispara · Comparte · Conecta`)
};

const fr_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot · Share · Connect`)
};

const de_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot · Share · Connect`)
};

const ja_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影 · 共有 · 繋がる`)
};

const zh_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄 · 分享 · 连接`)
};

const ar_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صوّر · شارك · تواصل`)
};

const id_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potret · Bagikan · Hubungkan`)
};

const it_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta · Condividi · Connetti`)
};

const ru_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимай · Делись · Соединяй`)
};

const pt_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografe · Compartilhe · Conecte`)
};

const ko_shoot_share_connect = /** @type {(inputs: Shoot_Share_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`촬영 · 공유 · 연결`)
};

/**
* | output |
* | --- |
* | "Shoot · Share · Connect" |
*
* @param {Shoot_Share_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shoot_share_connect = /** @type {((inputs?: Shoot_Share_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shoot_Share_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shoot_share_connect(inputs)
	if (locale === "es") return es_shoot_share_connect(inputs)
	if (locale === "fr") return fr_shoot_share_connect(inputs)
	if (locale === "de") return de_shoot_share_connect(inputs)
	if (locale === "ja") return ja_shoot_share_connect(inputs)
	if (locale === "zh") return zh_shoot_share_connect(inputs)
	if (locale === "ar") return ar_shoot_share_connect(inputs)
	if (locale === "id") return id_shoot_share_connect(inputs)
	if (locale === "it") return it_shoot_share_connect(inputs)
	if (locale === "ru") return ru_shoot_share_connect(inputs)
	if (locale === "pt") return pt_shoot_share_connect(inputs)
	return ko_shoot_share_connect(inputs)
});